<div class="flex flex-row items-center justify-between gap-5">
    <div class="flex flex-col gap-2 relative minw-44 w-1/2" *ngIf="list?.length || single">
        <h5 class="text-xs text-zen font-medium">{{ 'txt_send_to'| translate:language:ModuleNames.Shared }}</h5>
        <div
            class="text-sm rounded text-zen border bg-white border-zen border-opacity-25 px-3 h-9 gap-1  truncate flex flex-row justify-start items-center">
            <ng-container *ngIf="list.length">
                <span class="bg-exp bg-opacity-10 rounded-r-full rounded-l-full py-1 px-2"
                    *ngFor="let item of list | slice:0:4; let i=index">{{item.name}} </span>
                <div [@child4] *ngIf="list.length > 4"> + {{list.length - 4}}</div>
            </ng-container>
            <ng-container *ngIf="single">
                <span class="bg-exp bg-opacity-10 rounded-r-full rounded-l-full py-1 px-2">{{single.name}} </span>
            </ng-container>

        </div>
    </div>
    <div *ngIf="emailObject?.subject" class="flex flex-col w-full items-stretch">
        <z-input [maxCount]="mdCount" [required]="true" [language]="language"
            [label]="'txt_subject_line'| translate:language:ModuleNames.Shared"
            [(ngModel)]="emailObject.subject"></z-input>
    </div>

</div>

<div class="relative mt-5" *ngIf="emailObject.body">
    <!-- <angular-editor [iframe]='false' [maxlength]='hugeCount' (ngModelChange)="updateChangedValue($event)"
        [ngModel]="body" [config]="editorConfig">
    </angular-editor> -->
    <email-editor (ngModelChange)="updateChangedValue($event)" [ngModel]="body"></email-editor>
    <!-- <div #button class="angular-editor-toolbar-set inline-block min-h-8 mt-2" (click)="resetClicked()">
        <span zenButton styles="secondary height-10">{{ "txt_ResetTemp_946" | translate:language:ModuleNames.Shared
            }}</span>
    </div> -->
    <div
        class="flex flex-row justify-between items-center rounded-lg bg-zen-blueaccent bg-opacity-5 px-5 py-5 mt-5 gap-5">
        <div class="flex flex-row items-start gap-2">
            <i class="text-zen-blueaccent fal fa-info-circle"></i>
            <h5 class="text-zen text-xs"> {{'txtTemplateEmail'| translate:language:ModuleNames.Shared}} </h5>
        </div>
        <a class="btn cancel whitespace-nowrap text-center break-normal rounded-md px-5 leading-10 uppercase text-xs font-medium"
            (click)="resetClicked()">
            {{'txtDefaultTemplate'| translate:language:ModuleNames.Shared}} </a>
    </div>
</div>